import {createContext, useContext} from 'react';

import {baseTheme} from '@repo/shared-web/theme/theme_base';
import type {FrontendTheme} from '@repo/shared-web/theme/theme_model';

export const ThemeContext = createContext<FrontendTheme>({...baseTheme});
export function useTheme(): FrontendTheme {
  return useContext(ThemeContext);
}
